import { render } from "./Sprint.vue?vue&type=template&id=0c7cfb20&scoped=true"
import script from "./Sprint.vue?vue&type=script&lang=js"
export * from "./Sprint.vue?vue&type=script&lang=js"

import "./Sprint.vue?vue&type=style&index=0&id=0c7cfb20&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c7cfb20"

export default script